
/**
 * Handle promise process:
 * https://github.com/pirateminds/redux-pirate-promise
 * The library provide possibility to handle request, response, error
 * globally via overriding the default params in the redux-pirate-promise.
 * By the default it doenst modify the flow.
 * You can work with promises like with pure function without any overhead
 * It bit changed to original redux-pirate-promise - by the default
 * library not patch the content going thought the pure function without promise responses
 */
export default (params) => {
    let {
        // @ts-ignore
        request = (data, next) => ({}),
        response = (data, next) => next(data),
        error = (data, next) => next(data),
    } = params;

    return (next) => (action) => {
        let { promise, type, ...rest } = action;

        if (typeof action.then === "function") {
            request({ ...rest, type: type }, next);
            // new way working with promises
            return action.then(
                (result) => {
                    response({ ...rest, result, type: type }, next);
                    // set delay to be sure that changes pass to the state
                    return new Promise(resolve => setTimeout(() => resolve(result)));
                },
                (err) => {
                    console.log('reducer error', err);
                    error({ ...rest, error: err, type: type }, next);
                    return Promise.reject(err);
                },
            );
        } else {
            /**
             * NODE:
             * We cant handle errors in pure function only in promisified function
             */
            if (!promise) {
                response({ ...rest, type: type }, next)
                return action;
            }
            // old way working with promise param
            request({ ...rest, type: type }, next);

            return promise().then(
                (result) => {
                    response({ ...rest, result, type: type }, next);
                    return result;
                },
                (err) => {
                    error({ ...rest, error: err, type: type }, next);
                },
            );
        }
    };
};



// WEBPACK FOOTER //
// ./src/store/promise-middleware.js